import React from "react";
export default class Error extends React.Component{
    render(){
        return(
            <div>
                Error- Page Not Found
            </div>
        )
    }
}